<template>
  <div
    v-if="data.mark === true"
    class="moderation"
    :class="moderationSectionClass"
  >
    <div class="moderation__inner">
      <Icon name="corner-down-right" class="moderation__arrow" />

      <section class="moderation__comments">
        <div class="comment">
          <p v-if="data.comment" class="comment__meta">
            <span class="comment__user"> {{ data.user }} </span>
            <span class="comment__date">
              {{ data.date | moment("YYYY-MM-DD") }}
            </span>
          </p>
          <p v-if="data.comment" class="comment__message">
            {{ data.comment }}&nbsp;
          </p>
          <p v-if="!data.comment" class="comment__message">
            Oznaczone jako niezgodne. Brak komentarza.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import BaseAdminCertificationComment from "./BaseAdminCertificationComment";
import ModelFactory from "@/model/ModelFactory";

export default {
  name: "BaseUserCertificationComment",
  extends: BaseAdminCertificationComment,
  computed: {
    currentComment() {
      let current = this.comments; ///.filter(item => item.type === "previous");
      return current.length > 0
        ? current[0]
        : ModelFactory.create("CommentModel");
    }
  }
};
</script>

<style lang="scss"></style>
